class WebSocketService {
  constructor() {
    this.ws = null;
    this.callbacks = new Set();
    this.loggingCallbacks = new Set();
  }

  connect(sessionKey) {
    if (this.ws) {
      console.log("WebSocket already exists");
      return;
    }

    console.log("Creating WebSocket with session key:", sessionKey);
    this.ws = new WebSocket(`ws://echodemo.com/api/ws?token=${sessionKey}`);

    this.ws.onopen = () => {
      console.log("WebSocket connected successfully");
      this.notifyCallbacks();
    };

    this.ws.onclose = () => {
      console.log("WebSocket connection closed");
      this.ws = null;
      this.notifyCallbacks();
    };

    this.ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (message.type === 'logging') {
        this.notifyLoggingCallbacks(message.data);
      }
      this.notifyCallbacks(message);
    };

    return this.ws;
  }

  addCallback(callback) {
    this.callbacks.add(callback);
    console.log("a callback has been added");
  }

  removeCallback(callback) {
    this.callbacks.delete(callback);
  }

  notifyCallbacks(message) {
    this.callbacks.forEach(callback => callback(this.ws, message));
  }

  addLoggingCallback(callback) {
    this.loggingCallbacks.add(callback);
  }

  removeLoggingCallback(callback) {
    this.loggingCallbacks.delete(callback);
  }

  notifyLoggingCallbacks(logMessage) {
    this.loggingCallbacks.forEach(callback => callback(logMessage));
  }

  sendMessage(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ message }));
    }
  }
}

export default new WebSocketService();